export enum Currencies{
  Euro = 'EUR',
  Yen = 'JPY',
  Dollar = 'USD',
}
